import { render } from "./BlackSn.vue?vue&type=template&id=230f1db5&scoped=true"
import script from "./BlackSn.vue?vue&type=script&lang=js"
export * from "./BlackSn.vue?vue&type=script&lang=js"

import "./BlackSn.vue?vue&type=style&index=0&id=230f1db5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230f1db5"]])

export default __exports__